import coverImg from "assets/images/v141/cover.webp"

export const v141Config = {
  cover: {
    en: coverImg,
  },
}
